export default "__VITE_ASSET__CTIrpQEs__"